var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGives(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.949219,
    width: 44.4138,
    height: 44.4138,
    rx: 7.4023,
    fill: "#212224"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1875 18.6055V23.5405L24.0381 25.3911",
    stroke: "white",
    strokeWidth: 1.85063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4992 29.0353C33.5181 30.1254 34.5275 30.6706 34.5275 31.5603C34.5275 32.4499 33.5181 32.9951 31.4992 34.0853L30.1244 34.8277C28.5739 35.665 27.7988 36.0836 27.4259 35.7792C26.5131 35.0338 27.9352 33.11 28.2851 32.4285C28.6397 31.7379 28.6333 31.3701 28.2851 30.6921C27.9352 30.0106 26.5131 28.0868 27.4259 27.3413C27.7988 27.037 28.5739 27.4556 30.1244 28.2928L31.4992 29.0353Z",
    stroke: "white",
    strokeWidth: 1.85063
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.455 35.814C23.0389 35.8564 22.6164 35.8781 22.1891 35.8781C15.3752 35.8781 9.85156 30.3544 9.85156 23.5406C9.85156 16.7268 15.3752 11.2031 22.1891 11.2031C29.0028 11.2031 34.5266 16.7268 34.5266 23.5406C34.5266 24.3856 34.4416 25.2109 34.2798 26.0081",
    stroke: "white",
    strokeWidth: 1.85063,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGives);
export default __webpack_public_path__ + "static/media/gives.30a6594f8cb3d6dab1bee1b34a8e08af.svg";
export { ForwardRef as ReactComponent };